import {RouteConfig} from 'vue-router'
import Layout from '@/layout/index.vue'

const equipRouter: RouteConfig = {
  path: '/trainplanManage',
  redirect: 'noredirect',
  name: 'trainplanManage',
  component: Layout,
  children: [
    {
      path: 'trainplanManage',
      component: () => import('@/views/trainplanManage/index.vue'),
      name: 'trainplanManage',
      meta: {
        title: '训练计划管理',
        icon: 'resource',
        requireAuth: true,
      }
    },
  ]

}

export default equipRouter
